module.exports = __webpack_public_path__ + "static/IMG_2259-5989d70a75a44bbfe3299f45b68d7116.jpg";